import React from 'react';
import PropTypes from 'prop-types';

import { getClickAttrs } from '../../../Analytics/gtag';
import TrackedClick from '../../../Analytics/TrackedClick';
import { globalSearchIDs } from '../../../Analytics/testIDConfig';
import { LeagueTypeIds } from '../../../../utils/types';
import { useStatsig } from '../../../hooks/useStatsig';

const TeamLeaguesPickleballSearchPills = ({ onTeamLeagueClick }) => {
    const { checkGate, featureGates } = useStatsig();
    const { ADULT_TEAM_PICKLEBALL, JUNIOR_TEAM_PICKLEBALL } = LeagueTypeIds;
    const isAdultTeamPickleballEnabled = checkGate(featureGates.ADULT_TEAM_PICKLEBALL);
    const isJuniorTeamPickleballEnabled = checkGate(featureGates.JUNIOR_TEAM_PICKLEBALL);

    const handleOnClick = (leagueType) => {
        onTeamLeagueClick(leagueType);
    };

    return (
        <>
            {isAdultTeamPickleballEnabled && (
                <TrackedClick
                    eventName="Global Search Category Clicked"
                    label="Adult Team Pickleball"
                    traits={{
                        entityType: 'Adult Team Pickleball',
                    }}
                >
                    <button
                        type="button"
                        className={`btn btn-sm btn-primary`}
                        onClick={() => handleOnClick(ADULT_TEAM_PICKLEBALL)}
                        {...getClickAttrs({
                            category: 'Global Search Category',
                            context: `Adult Team Pickleball`,
                            location: 'Global search CTA',
                            testid: `${
                                globalSearchIDs.adultTeamPickleball.component
                            }-${globalSearchIDs.adultTeamPickleball.location}-${
                                globalSearchIDs.adultTeamPickleball.id
                            }`,
                        })}
                    >
                        Adult Team Pickleball
                    </button>
                </TrackedClick>
            )}
            {isJuniorTeamPickleballEnabled && (
                <TrackedClick
                    eventName="Global Search Category Clicked"
                    label="Junior Team Pickleball"
                    traits={{
                        entityType: 'Junior Team Pickleball',
                    }}
                >
                    <button
                        type="button"
                        className={`btn btn-sm btn-primary`}
                        onClick={() => handleOnClick(JUNIOR_TEAM_PICKLEBALL)}
                        {...getClickAttrs({
                            category: 'Global Search Category',
                            context: `Junior Team Pickleball`,
                            location: 'Global search CTA',
                            testid: `${
                                globalSearchIDs.juniorTeamPickleball.component
                            }-${
                                globalSearchIDs.juniorTeamPickleball.location
                            }-${globalSearchIDs.juniorTeamPickleball.id}`,
                        })}
                    >
                        Junior Team Pickleball
                    </button>
                </TrackedClick>
            )}
        </>
    );
};

TeamLeaguesPickleballSearchPills.propTypes = {
    onTeamLeagueClick: PropTypes.func.isRequired,
};

export default TeamLeaguesPickleballSearchPills;
